import * as api from '../api';

export const fetchCashierTrackingData = (args: any): Promise<any> => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/statistics/sites/${siteId}/cashier-tracking`, args);
};
